import { RolesConstants } from './roles.constants';

export const RoutingUseHash = true;

export enum RouteConstants {
  // Common
  EMPTY = '',
  CREATE = 'create',
  CLONE = 'clone',
  EDIT = 'edit',
  DISPLAY = 'display',
  VIEWER = 'viewer',
  PREVIEWER = 'previewer',
  BACK = 'back',
  OTHER = '**',

  // Route Params
  ID = ':id',
  VERSION = ':version',
  NEW_VERSION = ':new_version',

  // Login
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot-password',
  RESTORE_PASSWORD = 'restore-password',

  // Dashboard
  DASHBOARD = 'dashboard',

  //Users
  USERS = 'users',

  //Guías clínicas
  CECOS = 'CECOS',
  USVB = 'USVB',
  USVA = 'USVA',
  SVB = 'SVB',
  SVA = 'SVA',
  FARMACS = 'farmacs',
  ESCALES = 'escales',
  INT = 'INT',
  HNT = 'HNT',
  procediments = 'procediments',
  codisActivacio = 'codisActivacio',
  GLOSSARY = 'glossaris',
  ABREVIACIONS = 'abreviacions',
  PATHOPHYSIOLOGY = 'FISTRA',
  ETHIC = 'ETICA',
  LEGAL = 'LEGAL',
  MANUALS = 'MANUALS',
  VIEW = ':view',
  repositori = 'repositori',

  //Content editor and viewer
  CONTENT_EDITOR_AND_VIEWER = 'cev',
  CONTENT_PREVIEWR = 'cpreviewer',

  //Contact
  CONTACT = 'CONTACTE'
}

export const RoutePermissionByRoleConstants: Record<string, RolesConstants[]> = {
  //For routes with permissions specify an array with the permissions that the user must have to access
  // (as long as one is met, he can access)
  // DASHBOARD: [],
  USERS: [RolesConstants.ADMINISTRADOR],
  CONTENT_CREATOR_EDITOR: [RolesConstants.ADMINISTRADOR, RolesConstants.RESPONSABLE]
};
